import {
  alphanumericOnlyRegex,
  dateRegex,
  dateReplacePattern,
  digitsOnlyRegex,
  multipleDashesRegex,
  multipleSpacesRegex,
  phoneRegex,
  phoneReplacePattern,
  ssnRegex,
  ssnReplacePattern,
  ssnMaskPattern,
  zipRegex,
  zipReplacePattern
} from '@/constants';

import currency from 'vue2-filters/src/other/currency';

const stripNonDigitChars = (value) => {
  return value ? value.replace(digitsOnlyRegex, '') : value;
};

const stripNonAlphanumericChars = (value) => {
  return value ? value.replace(alphanumericOnlyRegex, '') : value;
};

export default {
  alphanumeric: {
    format: function (value) {
      return stripNonAlphanumericChars(value);
    },
    construct: function (value) {
      return this.format(value);
    },
    deconstruct: function (value) {
      return this.format(value);
    }
  },
  date: {
    format: function (value) {
      return value ? value.replace(dateRegex, dateReplacePattern) : value;
    },
    construct: function (value) {
      return this.format(value);
    },
    deconstruct: function (value) {
      return this.format(value);
    }
  },
  phone: {
    construct: function (value) {
      return value ? value.replace(phoneRegex, phoneReplacePattern) : value;
    },
    deconstruct: function (value) {
      return stripNonDigitChars(value);
    }
  },
  zip: {
    construct: function(value) {
      return value ? value.replace(zipRegex, zipReplacePattern) : value;
    },
    deconstruct: function (value) {
      return stripNonDigitChars(value);
    }
  },
  bankAccountNumber: {
    format: function (value) {
      if (value) {
        // Replace characters that aren't numbers, spaces, or dashes
        let formattedValue = value.replace(/[^\d\s-]+/g, '');
        // Replace 2+ spaces with one space
        formattedValue = formattedValue.replace(multipleSpacesRegex, ' ');
        // Replace 2+ dashes with one dash
        return formattedValue.replace(multipleDashesRegex, '-');
      }
      return value;
    },
    construct: function(value) {
      return this.format(value);
    },
    deconstruct: function (value) {
      return this.format(value);
    }
  },
  ssn: {
    construct: function (value) {
      return value ? value.replace(ssnRegex, ssnMaskPattern) : value;
    },
    deconstruct: function (value) {
      return value ? value.replace(ssnRegex, ssnReplacePattern) : value;
    },
    formatForAPI: function (value) {
      return stripNonDigitChars(value);
    }
  },
  integer: {
    format: function (value) {
      let int = value || value === 0 ? Math.round(value) : value;
      return !isNaN(int) ? int : value;
    },
    construct: function (value) {
      return this.format(value);
    },
    deconstruct: function (value) {
      return this.format(value);
    }
  },
  uppercase: {
    construct: function (value) {
      return value.toUpperCase();
    }
  },
  currency: {
    construct: function (value) {
      let val = (value !== null && typeof value !== 'undefined') ? value.toString() : '';
      return currency(val.replace('$', '').replace(',', ''), '');
    },
    deconstruct: function (value) {
      let val = (value !== null && typeof value !== 'undefined') ? value.toString() : '';
      return val.replace('$', '').replace(',', '');
    }
  },
  numerical: {
    format: function (value) {
      return stripNonDigitChars(value);
    },
    construct: function (value) {
      return this.format(value);
    },
    deconstruct: function (value) {
      return this.format(value);
    }
  },
  percent: {
    format: function (value) {
      let int = value || value === 0 ? Math.round(value) : value;
      return !isNaN(int) ? int.toString().slice(0, 3) : value.slice(0, 3);
    },
    construct: function (value) {
      return this.format(value);
    },
    deconstruct: function (value) {
      return this.format(value);
    }
  }
};